
import TableList from "@components/templates/tablelist";
import compUpdate from "./update.vue";
import compTakeup from "./alerttakeup.vue";
import {
    HttpLimitOrgList,
    HttpLimitWarehouseList
} from "@/service/setting.js";
import { mapState, mapGetters } from "vuex"
export default {
    mixins: [TableList],
    components: {
        compUpdate,
        compTakeup,
    },
    data () {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                }
            },
            Searchs: {
                show: true,
                labelWidth: 100,
            },
            Plugins: { show: true },
            limitwarehouselist: [],
        };
    },
    created () {
        // fbb.ability.view
        this.orgOpera = this.handleAuth('fbb.ability.view');
        HttpLimitWarehouseList().then(res => {
            this.limitwarehouselist = res.data
        })
    },
    methods: {
        ajaxRequest: HttpLimitOrgList,
        exportQuery () {
            let searchData = {}
            Object.keys(this.formData.search).map(item => {
                searchData[`search[${item}]`] = this.formData.search[item]
            });
            this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/handelAbility/export", {
                ...searchData
            }, {
                executor: 'request',
                download: true,
            }).catch(err => {
                // this.$VMessage.error(err.message);
            })
        },
        handleOperates (params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case 'exportQuery':
                    this.exportQuery(params)
                    break
                case 'add':
                    this.operate = {
                        title: this.$t('erp.product.new_add', { defaultValue: '添加' }),
                        show: true,
                        width: 600,
                        component: "compUpdate",
                        activeid: params,
                        querytype: 'add',
                        showFooter: false
                    }
                    break;
                case 'query':
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 600,
                        component: "compUpdate",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case 'edit':
                    this.operate = {
                        title: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                        show: true,
                        width: 600,
                        component: "compUpdate",
                        activeid: params,
                        querytype: 'edit',
                        showFooter: false
                    }
                    break;
                case 'importExcel':
                    this.operate = {
                        show: true,
                        title: this.$t('fbb.alloment.import_data', { defaultValue: '导入数据' }),
                        width: 460,
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_FBB + "/api/v2/handelAbility/importCalculate",
                        name: "multipartFile",
                        component: "compUpload",
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/handelAbility/itemTemplate", {}, 'download')
                        },
                    }
                    break;
                case 'takeup':
                    this.operate = {
                        show: true,
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        actived: params,
                        component: "compTakeup",
                        width: 800,
                        showFooter: false,
                    }
                    break;
            }
        },
        getOperateNodeMap (row) {
            const { id } = row
            return [{
                label: this.$t('global.common.query', { defaultValue: '查看' }),
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                show: true,
                params: id,
                operate: 'edit'
            }]
        },
    },
    computed: {
        ...mapGetters("dictionary", [
            "getWarehouseList",
            "getSelfmanageorgList",
        ]),
        ToolsData () {
            return [
                {
                    name: this.$t('erp.product.new_add', { defaultValue: '添加' }),
                    operate: "add",
                    show: this.orgOpera,
                    theme: "primary",
                },
                {
                    name: this.$t('fbb.alloment.muti_import', { defaultValue: '批量导入' }),
                    operate: 'importExcel',
                    show: this.orgOpera,
                    theme: 'info'
                },
                {
                    name: this.$t('global.common.export', { defaultValue: '导出' }),
                    operate: 'exportQuery',
                    // show: this.handleAuth('fbb.blacklist.export'),
                    theme: 'success'
                }
            ]
        },
        SearchsData () {
            let widthStyle = 'width: 150px'
            return [
                {
                    label: this.$t('fbb.alloment.date', { defaultValue: "日期" }),
                    tag: 'vDatepicker',
                    key: 'BT_capacityDate',
                    show: true,
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.warehouse', { defaultValue: '仓库' }),
                    key: 'IN_orgWarehouseCode',
                    show: true,
                    tag: 'Select',
                    options: this.limitwarehouselist.map(item => {
                        return {
                            label: item.code + '(' + item.title + ')',
                            value: item.code
                        }
                    }),
                    props: {
                        filterable: true,
                        clearable: true,
                        multiple: true
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('bi.work.task_org_id', { defaultValue: '组织' }),
                    key: 'IN_organizationId',
                    show: true,
                    tag: 'Select',
                    options: this.getSelfmanageorgList,
                    props: {
                        filterable: true,
                        clearable: true,
                        multiple: true
                    },
                    style: widthStyle
                },

                {
                    label: this.$t('erp.b2c.shipping_method', { defaultValue: '发货方式' }),
                    tag: 'Input',
                    key: 'IN_carrierCode',
                    show: true,
                }
            ]
        },
        columns () {
            return [
                {
                    title: this.$t('global.common.actions', { defaultValue: '操作' }),
                    width: this.orgOpera ? 70 : 0,
                    render: this.getOperateNodes,
                },

                {
                    title: this.$t('fbb.alloment.date', { defaultValue: "日期" }),
                    key: 'capacityDate'
                },
                {
                    title: this.$t('bi.work.task_org_id', { defaultValue: '组织' }),
                    render: (h, { row }) => {
                        let clientItem = this.getSelfmanageorgList.filter(item => {
                            return row.organizationId === item.value
                        })[0];
                        return <div>{clientItem ? clientItem.label : '--'}</div>
                    }
                },
                {
                    title: this.$t('global.common.warehouse', { defaultValue: '仓库' }),
                    key: 'orgWarehouseCode'
                },
                {
                    title: this.$t("erp.product_channel.type", { defaultValue: "类型" }),
                    key: 'type',
                    render: (h, { row }) => {
                        return <div>{row.type == 0 ? '物流产品' : '卡车模式'}</div>
                    }
                },
                {
                    title: this.$t('erp.b2c.shipping_method', { defaultValue: '发货方式' }),
                    key: 'carrierCode',
                },
                {
                    title: this.$t('', { defaultValue: '限额' }),
                    key: 'capacity',
                },
                {
                    title: this.$t('', { defaultValue: '占用' }),
                    render: (h, { row }) => {
                        return <div>
                            <a onClick={this.handleOperates.bind(this, row.id, 'takeup')}>{row.capacity - row.remainCapacity}</a>
                        </div>
                    }
                },
                {
                    title: this.$t('', { defaultValue: '可用' }),
                    key: 'remainCapacity'
                },
                {
                    title: this.$t('global.common.updatedAt', { defaultValue: '更新时间' }),
                    key: 'updatedAt',
                }
            ];
        },

    }

};
